import { z } from "zod";
import { ShippingRuleSchema } from "../common";
import {
  TaxSettingsSchema,
  ResourceRefSchema,
  SpecificTaxRateSchema,
} from "../taxes";

export { TaxSettingsSchema, ResourceRefSchema, SpecificTaxRateSchema };

// --- GET /admin/shop/logistics ---
export const ShopConfigResponseSchema = z.object({
  country_code: z.string().length(2),
  currency: z.string(),
  timezone: z.string(),

  // Mapeo directo del JSONB 'shipping_settings' en DB
  shipping: z.object({
    coverage: z.object({
      min_score: z.number().min(0).max(100),
      excluded_cities: z.array(z.string()),
    }),
    offices: z.object({
      enabled: z.boolean(),
      label: z.string().optional(),
      min_score: z.number().min(0).max(100),
    }),
    rates: z.array(ShippingRuleSchema),
  }),
  tax: TaxSettingsSchema,
});

// --- PUT /admin/shop/logistics ---
export const UpdateShopLogisticsRequestSchema = z.object({
  coverage: z
    .object({
      min_score: z.number().min(0).max(100),
      excluded_cities: z.array(z.string()),
    })
    .optional(),
  offices: z
    .object({
      enabled: z.boolean(),
      label: z.string().optional(),
      min_score: z.number().min(0).max(100),
    })
    .optional(),
  rates: z.array(ShippingRuleSchema).optional(),
  tax: TaxSettingsSchema.optional(),
});

export type ShopConfigResponse = z.infer<typeof ShopConfigResponseSchema>;
export type UpdateShopLogisticsRequest = z.infer<
  typeof UpdateShopLogisticsRequestSchema
>;
